import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_76: FaireProductEntity = {
  token: "starter_collection_76",
  type: "product",
  name: "Tinned Fish Gift Set",
  brandName: "Fishwife",
  imageUrl:
    '"https://cdn.faire.com/fastly/80244247042b7b9784ad252774670675b676000336abd888e83918d55fa2f6cc.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=2458',
  priceDollars: 45,
  msrpDollars: 90,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
